import { useContext, useMemo } from 'react';
import { DictionariesContext } from '@/creditflowresearch/application/Dictionaries/DictionariesContext';
import { useDictionariesContext } from '@/creditflowresearch/application/Dictionaries/v2/DictionariesContext';
import { resolveResearchDocumentGroupList } from '@/creditflowresearch/application/Research/utils';
import type { IResearchDocumentGroup } from '@/creditflowresearch/domain/vo/research/IResearchDocumentGroup';

export const useResearchDocumentGroupList = (): IResearchDocumentGroup[] => {
  const legacy = useContext(DictionariesContext);
  const { documentTypeGroups } = useDictionariesContext();

  return useMemo(
    () => resolveResearchDocumentGroupList(legacy?.researchDocumentGroupList, documentTypeGroups?.getAll()),
    [legacy?.researchDocumentGroupList, documentTypeGroups],
  );
};
